module.exports = __webpack_public_path__ + "img/1454463931.c060e494.jpg";